import { HUMAN_REVIEW_OUTCOME, HUMAN_REVIEW_STATUS } from "@/ai-coding-outputs/constants";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { Database } from "@/integrations/supabase/types";

type ReviewStatus = Database["public"]["Enums"]["human_review_status"];
type ReviewOutcome = Database["public"]["Enums"]["human_review_outcome"];

const WORK_IN_PROGRESS = "Work in progress";

const COMPLETE_LABELS: Record<ReviewOutcome, string> = {
  [HUMAN_REVIEW_OUTCOME.APPROVED]: "Approved",
  [HUMAN_REVIEW_OUTCOME.REJECTED]: "Rejected",
};

const BADGE_CLASSES =
  "ml-2 inline-flex items-center rounded-full border border-gray-300 bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-700";

export const ReviewStateBadge = ({ status, outcome }: { status: ReviewStatus; outcome: ReviewOutcome | null }) => {
  // A revert leaves the stale outcome in place, so a pending review reports work in progress regardless.
  if (status === HUMAN_REVIEW_STATUS.COMPLETE && outcome) {
    return <span className={BADGE_CLASSES}>{COMPLETE_LABELS[outcome]}</span>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn(BADGE_CLASSES, "shrink-0 cursor-default")} tabIndex={0} aria-label={WORK_IN_PROGRESS}>
            WIP
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>{WORK_IN_PROGRESS} — this review has not been finalised.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
